import i18n from 'i18next';

import translationPTBR from '@/locales/pt-br.json';

class Translation {
  public static async initI18n(): Promise<void> {
    await i18n
      .init({
        resources: {
          'pt-BR': {
            translation: translationPTBR,
          },
        },
        lng: 'pt-BR',
        fallbackLng: 'pt-BR',
        keySeparator: '.',
        interpolation: {
          escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        },
      });
  }
}

export default Translation;
